import React from "react";
import HelpButton from "../HelpContent/HelpButton";
import {
  BroadcastType,
  selectBroadcast,
  setBroadcast,
} from "../store/slices/broadcastSlice";
import BroadcastCommsSelector from "./BroadcastCommsSelector";
import Way1CommunicationIcon from "../../assets/icons/icon_1_way-01.svg2";
import Way2CommunicationIcon from "../../assets/icons/icon_2_way-01.svg2";
import DraftIcon from "../../assets/icons/edit-01.svg2";
import PublishedIcon from "../../assets/icons/library_broadcast.svg2";
import ArchivedIcon from "../../assets/icons/close.svg2";
import MyIcon from "../Common/MyIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faChevronLeft,
  faChevronRight,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { categories, industryTypes } from "../helpers/categories";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";
import { proxyAPI } from "../proxyAPI";
import { Button } from "react-bootstrap";

export default function BroadcastSettingsPage({
  confirmFixedBroadcast,
  update,
}: {
  confirmFixedBroadcast: any;
  update?: () => void;
}) {
  const values = useSelector(selectBroadcast);
  const dispatch = useDispatch();
  const confirmDialog = useConfirmDialog();
  const setValues = (f: (v: BroadcastType) => BroadcastType) =>
    dispatch(setBroadcast(f(values)));
  const { broadcastPage, broadcastUUID } = useParams();

  return (
    <div>
      <div className="row my-2 mx-0 gy-3 gx-5">
        <div className="offset-xl-1 col-xl-5 offset-xxl-2 col-xxl-4 border-end border-1">
          <div className="mb-2">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold"> Broadcast Name</h5>
              <HelpButton helpKey="broadcast-name" />
            </div>

            <Input
              value={[(values as any).Label]}
              onChange={([v]: any) =>
                setValues((p: any) => ({
                  ...p,
                  Label: v,
                }))
              }
              options={[]}
            />
          </div>
          <div className="mb-2">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold">Description</h5>
              <HelpButton helpKey="broadcast-description" />
            </div>

            <Input
              inputType="textArea"
              value={[(values as any).Description]}
              onChange={([v]: any) =>
                setValues((p: any) => ({
                  ...p,
                  Description: v,
                }))
              }
              options={[]}
            />
          </div>{" "}
          <div className="mb-2">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold">Reference</h5>
              <HelpButton helpKey="broadcast-reference" />
            </div>

            <Input
              value={[(values as any).Reference]}
              onChange={([v]: any) =>
                setValues((p: any) => ({
                  ...p,
                  Reference: v,
                }))
              }
              options={[]}
            />
          </div>
          <div className="mb-2">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold">Industry</h5>
              {/* <HelpButton helpKey={} /> */}
            </div>
            <div className=" bg-white rounded-3">
              <Input
                inputType="select"
                isMulti
                isValidNewOption={(o) => o}
                value={values?.TagsMap?.industry || []}
                onChange={(values: any) =>
                  setValues((prev) => ({
                    ...prev,
                    TagsMap: {
                      ...(prev.TagsMap || { category: [], folder: [] }),
                      industry: values,
                    },
                  }))
                }
                loadOptions={async (s, prevOptions) => {
                  const { data: items, total } = await proxyAPI({
                    prefix: "logic/workflows/api",
                    url: `tags?search=${s}&kind=industry`,
                  });
                  return {
                    options: items.map((item) => ({
                      value: item,
                      label: item,
                    })),
                    hasMore: items.length < total,
                  };
                }}
              />
            </div>
          </div>
          <div className="mb-2">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold">Category</h5>
              {/* <HelpButton helpKey={} /> */}
            </div>{" "}
            <div className="bg-white rounded-3">
              <Input
                inputType="select"
                isMulti
                isValidNewOption={(o) => o}
                value={values?.TagsMap?.category || []}
                onChange={(values: string[]) =>
                  setValues((prev) => ({
                    ...prev,
                    TagsMap: {
                      ...(prev.TagsMap || { industry: [], folder: [] }),
                      category: values,
                    },
                  }))
                }
                loadOptions={async (s, prevOptions) => {
                  const { data: items, total } = await proxyAPI({
                    prefix: "logic/workflows/api",
                    url: `tags?search=${s}&kind=category`,
                  });
                  return {
                    options: items.map((item) => ({
                      value: item,
                      label: item,
                    })),
                    hasMore: items.length < total,
                  };
                }}
              />
            </div>
          </div>
          <div className="mb-2">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold">Folder</h5>
              {/* <HelpButton helpKey={} /> */}
            </div>{" "}
            <div className="bg-white rounded-3">
              <Input
                inputType="select"
                isMulti
                isValidNewOption={(o) => o}
                value={values?.TagsMap?.folder || []}
                onChange={(values: string[]) =>
                  setValues((prev) => ({
                    ...prev,
                    TagsMap: {
                      ...(prev.TagsMap || { industry: [], category: [] }),
                      folder: values,
                    },
                  }))
                }
                loadOptions={async (s, prevOptions) => {
                  const { data: items, total } = await proxyAPI({
                    prefix: "logic/workflows/api",
                    url: `tags?search=${s}&kind=folder`,
                  });
                  return {
                    options: items.map((item) => ({
                      value: item,
                      label: item,
                    })),
                    hasMore: items.length < total,
                  };
                }}
              />
            </div>
          </div>
        </div>

        <div className="col-xl-5 col-xxl-4">
          <div className="mb-4">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold">Communication channels:</h5>
              <HelpButton helpKey="broadcast-comms-selector" />
            </div>
            <hr className="my-2" />
            <BroadcastCommsSelector />
          </div>
          <div className="mb-4">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold">Communication type:</h5>
              <HelpButton helpKey="broadcast-comms-types" />
            </div>
            <hr className="my-2" />
            <div className="row row-cols-2 g-3">
              {[
                {
                  value: "one-way",
                  label: "1-Way Communication",
                  icon: Way1CommunicationIcon,
                  subText: "Send one-way broadcast with replies disabled",
                  helpId: "broadcast-1-way",
                },
                {
                  value: "two-way",
                  label: "2-Way Communication",
                  icon: Way2CommunicationIcon,
                  subText: "Send two-way broadcast with replies enabled",
                  helpId: "broadcast-2-way",
                },
              ].map((c) => (
                <div className="col-12 col-sm-6" key={c.value}>
                  <button
                    type="button"
                    className={`btn w-100 h-100 bg-white p-3 pt-4 rounded-3 position-relative text-start border border-2 ${
                      values.CommsMethod === c.value ? "border-blue" : ""
                    }`}
                    onClick={async () => {
                      if (
                        c.value === "one-way" &&
                        (values.Handlers || []).filter(
                          (h) => !h.IsDeliveryStatus
                        ).length > 0 &&
                        !(await confirmDialog(
                          "Are you sure?",
                          "You have reply handlers in the broadcast. If you switch to 1-way communication method, you will lose your reply handlers."
                        ))
                      ) {
                        return;
                      }
                      confirmFixedBroadcast(() =>
                        setValues((prev: any) => ({
                          ...prev,
                          CommsMethod: c.value,
                          ...(c.value === "one-way"
                            ? {
                                Handlers: prev.Handlers.filter(
                                  (h: any) => h.IsDeliveryStatus
                                ),
                              }
                            : {}),
                        }))
                      );
                    }}
                  >
                    <div className="position-absolute top-0 start-0">
                      <HelpButton helpKey={(c as any).helpId} />
                    </div>
                    {values.CommsMethod === c.value ? (
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="position-absolute top-0 end-0 text-white bg-colored p-1"
                        style={{ borderBottomLeftRadius: 8 }}
                      />
                    ) : null}
                    <div className="d-flex align-items-center">
                      <MyIcon width={20} Icon={c.icon} className=" me-2" />
                      <div>
                        <div className=" fw-bold small overflow-hidden">
                          {c.label}
                        </div>
                        <div className="text-secondary small">{c.subText}</div>
                      </div>
                    </div>
                  </button>
                </div>
              ))}
            </div>
          </div>
          {broadcastUUID && broadcastUUID !== "new" && (
            <div className="mb-4">
              <div className="d-flex justify-content-between">
                <h5 className="fw-bold">Status:</h5>
                <HelpButton helpKey="broadcast-status" />
              </div>
              <hr className="my-2" />
              <div className="row row-cols-2 g-3">
                {[
                  {
                    value: "draft",
                    label: "Draft",
                    icon: DraftIcon,
                    subText:
                      "Draft broadcasts are not yet published and can be edited.",
                    helpId: "broadcast-draft",
                  },
                  {
                    value: "published",
                    label: "Published",
                    icon: PublishedIcon,
                    subText:
                      "Published broadcasts are active and can be sent. Once a broadcast is published, you can still edit it, but you should be cautious as changes may affect any scheduled sends.",
                    helpId: "broadcast-published",
                  },
                  {
                    value: "archived",
                    label: "Archived",
                    icon: ArchivedIcon,
                    subText:
                      "Archived broadcasts are read-only and cannot be sent. You can archive a broadcast when you want to keep it for record but don't want it to be active.",
                    helpId: "broadcast-archived",
                  },
                ].map((c) => (
                  <div className="col-12 col-sm-4" key={c.value}>
                    <button
                      type="button"
                      className={`btn w-100 h-100 bg-white p-3 pt-4 rounded-3 position-relative text-start border border-2 ${
                        values.Status === c.value ? "border-blue" : ""
                      }`}
                      onClick={async () => {
                        setValues((prev: any) => ({
                          ...prev,
                          Status: c.value,
                        }));
                      }}
                    >
                      <div className="position-absolute top-0 start-0">
                        <HelpButton helpKey={(c as any).helpId} />
                      </div>
                      {values.Status === c.value ? (
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="position-absolute top-0 end-0 text-white bg-colored p-1"
                          style={{ borderBottomLeftRadius: 8 }}
                        />
                      ) : null}
                      <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
                        <MyIcon width={20} Icon={c.icon} className=" me-2" />
                        <div className=" fw-bold small overflow-hidden text-center">
                          {c.label}
                        </div>
                        {/* <div className="text-secondary small">{c.subText}</div> */}
                      </div>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="text-center">
        <span className="fw-bold">Next:</span> Configure and setup your
        broadcast.
      </div>
      <div className="mx-auto mb-5 mt-3 d-flex justify-content-center gap-4">
        {broadcastUUID !== "new" && (
          <Button
            type="button"
            onClick={update}
            className="btn small bg-colored rounded-pill border-0 pe-4 fw-bold"
          >
            <span className="d-inline-block rounded-circle bg-body py-1 px-2 me-2 text-black">
              <FontAwesomeIcon icon={faSave} />
            </span>
            Update template
          </Button>
        )}
        <Link
          type="button"
          className="btn small bg-purple-gradient rounded-pill ps-4 fw-bold"
          to={`/library/broadcast/${broadcastUUID}/messages`}
        >
          Next
          <span className="d-inline-block rounded-circle bg-body py-1 px-2 ms-2">
            <FontAwesomeIcon icon={faChevronRight} />
          </span>
        </Link>
      </div>
    </div>
  );
}
